/**
 * FIXME I have fine-tuned drawings.  So I'd better substitute magic numbers to global variables or sth.
 * FIXME And I'd better subsitute the values of fine-tuning to symmetric values.
 * FIXME The current normal versions are Reserve.bak.34 and Canvas.bak.45.
 **/
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from "react-redux";

const NUM_OF_DAYS = 7;
const NUM_OF_MINUTES = 24 * 60 / 30; // 24 hours * 60 minuites / 30 minutes
const TIME_BIN = 30 * 60;
const MINUTES_UNIT = 30;

const Canvas = ({
  accounts,
  day,
  date,
  jabraNumber,
  drawingRegion,
  increment,
  minutesStyles,
  clearPreviousRectangle,
  selectedMenu,
  reserveOfDay,
  synced,
  processing,
  confirmedQueue
}) => {
  const pathname = useLocation().pathname;

  const [ reservedDetail, setReservedDetail ] = useState([]);
  var reservedStatus = [];
  const NOT_EXIST = -65535;
  var selectedReserved = null;
  var confirming = null;
  const [ previousLength, setPreviousLength ] = useState(0);

  var canvas = useRef();
  var canvasEle = null;
  var ctx = null;

  var cur = null;
  var offset = null; // offset changes only when the event mouseup occurs.
  var savedOffset = -1; // FIXME If we set savedOffset and/or savedHeight to null, we cannot instantly draw a rectangle at offset 0.  What value should I set?
  var savedHeight = -1;
  var start = null;
  var topleft = null;
  var height = null; // FIXME height begins at 0.  This is unnatural.  height should be begins at 0.  But I don't have time enough.
  var previousHeight = null;
  var widthUnit = increment.width + 1.0;
  var heightUnit = increment.height;
  var jitter = null;
  var resizable = false;
  var resized = true;
  var resizing = false;
  var contained = null;
  var atEdge = null;
  var noUp = null;
  var noDown = null;

  useEffect(() => {
    canvasEle = canvas.current;

    bindEvents();

    canvasEle.width = widthUnit + 1.0;
    canvasEle.height = drawingRegion.height + 2;
    ctx = canvasEle.getContext("2d");
    drawLinesOnCanvas(0, NUM_OF_MINUTES+1);

    makeReservedStatus(reservedDetail);

    if (synced);
      drawReserved(reservedDetail);

    return () => {
      unbindEvents();
    }
  }, [widthUnit, heightUnit, processing, reservedDetail]);

  useEffect(() => {
    makeReservedDetail(reserveOfDay);
  }, [reserveOfDay]);

  useEffect(() => {
    for (let i = 0; i < confirmedQueue.length; i++)
      addReserving(reservedDetail, confirmedQueue[i]);
  }, [confirmedQueue]);

  useEffect(() => {
    if (processing) {
      canvas.current.style.cursor = 'wait';
    } else if (!processing && confirmedQueue.length === 0)
      canvas.current.style.cursor = 'default';
  }, [processing]);

  const bindEvents = () => {
    if (canvasEle) {
      canvasEle.addEventListener('mouseup', onMouseUp);
      canvasEle.addEventListener('mousedown', onMouseDown);
      canvasEle.addEventListener('mousemove', onMouseMove);
      canvasEle.addEventListener('mouseenter', onMouseEnter);
      canvasEle.addEventListener('mouseleave', onMouseLeave);
    }
  }

  const unbindEvents= () => {
    if (canvasEle) {
      canvasEle.removeEventListener('mouseup', onMouseUp);
      canvasEle.removeEventListener('mousedown', onMouseDown);
      canvasEle.removeEventListener('mousemove', onMouseMove);
      canvasEle.removeEventListener('mouseenter', onMouseEnter);
      canvasEle.removeEventListener('mouseleave', onMouseLeave);
    }
  }

  const onMouseUp = e => {
    if (confirmedQueue.length !== 0 && confirmedQueue.length > previousLength)
      return;

    cur = { y: e.offsetY };
    start = Math.floor(cur.y / heightUnit);
    resizing = false;

    if (topleft === null && height === null && start !== NUM_OF_MINUTES && !reservedStatus[start].reserved) {
      savedOffset = start;
      topleft = savedOffset;
      savedHeight = 0;
    }

     if (reservedStatus[start] && reservedStatus[start].reserved && reservedStatus[start].index !== NOT_EXIST) {
      savedOffset = reservedDetail[reservedStatus[start].index].offset;
      savedHeight = reservedDetail[reservedStatus[start].index].height;
    } else if (contained && resizable && !noUp && !noDown) {
      savedOffset = topleft
      savedHeight = height;
    } else if (!contained && start !== NUM_OF_MINUTES && !reservedStatus[start].reserved) {
      savedOffset = start;
      topleft = savedOffset;
      savedHeight = 0;
      drawRectangle(savedOffset, savedHeight);
    }

    selectedReserved = selectReserved(start);

    if (savedOffset !== -1 && reservedStatus[savedOffset].index !== NOT_EXIST)
      confirming = reservedDetail[reservedStatus[savedOffset].index].confirming;
    else
      confirming = false;

    if (savedHeight >= 0)
      selectedMenu(date, savedOffset, savedHeight, selectedReserved, confirming);

    clearPreviousRectangle(day, savedOffset, savedHeight, contained, resizable, confirming, clearRectangleFromParent);

    resizable = false;
    noUp = false;
    noDown = false;
    previousHeight = 0;
  }

  // Introducing a new clearPreviousRectangle for a new reservedStatus.
  useEffect(() => {
    if (confirmedQueue.length < previousLength) {
      makeReservedDetail(reserveOfDay);
      return;
    }

    widthUnit = increment.width + 1.0;
    heightUnit = increment.height;

    canvasEle = canvas.current;

    bindEvents();

    canvasEle.width = widthUnit + 1.0;
    canvasEle.height = drawingRegion.height + 2;
    ctx = canvasEle.getContext("2d");
    drawLinesOnCanvas(0, NUM_OF_MINUTES+1);

    makeReservedStatus(reservedDetail);

    if (synced);
      drawReserved(reservedDetail);

    clearPreviousRectangle(day, savedOffset, savedHeight, contained, resizable, confirming, clearRectangleFromParent);
    setPreviousLength(confirmedQueue.length);

    resizable = false;
    noUp = false;
    noDown = false;
    previousHeight = 0;

    return () => {
      unbindEvents();
    }
  }, [confirmedQueue]);

  const onMouseDown = e => {
    cur = { y: e.offsetY };
    start = Math.floor(cur.y / heightUnit);

    if (savedOffset === null) // Here "null" of this condition is correct, not -1.
      resizable = true;
    else if (start === savedOffset) {
      resizable = true;
      atEdge = "top";
    } else if (start === savedOffset+savedHeight) {
      resizable = true;
      atEdge = "bottom";
    }

    if (start === savedOffset || (start >= savedOffset && start <= savedOffset+savedHeight))
      contained = true;
    else
      contained = false;

    // For changing reservedDetail after we update confirmedQueue.
    makeReservedStatus(reservedDetail);
  }

  // FIXME I might be able to normalize more.
  const onMouseMove = e => {
    cur = { y: e.offsetY };
    offset = Math.floor(cur.y / heightUnit);
    var upward = false;
    var downward = false;
    const topBorder = savedOffset * heightUnit;
    const bottomBorder = (savedOffset+savedHeight+1) * heightUnit;
    const borderFineTune = 8;
    var cursors=['default', 'ns-resize', 'pointer', 'wait' ];
    var currentCursor = 0;

    if (savedOffset !== -1
      && !reservedStatus[savedOffset].reserved
      && !resizing && (offset < savedOffset || savedOffset+savedHeight < offset)) {
      clearRectangle(0, NUM_OF_MINUTES-1);
      redrawLinesOnCanvas(0, NUM_OF_MINUTES-1);
      clearRectangle(savedOffset, savedHeight);
      drawReserved(reservedDetail);
      drawRectangle(savedOffset, savedHeight);
    } else if (savedOffset !== -1 && !reservedStatus[savedOffset].reserved && !resizing && (offset >= savedOffset || savedOffset+savedHeight >= offset)) {
      clearRectangle(0, NUM_OF_MINUTES-1);
      redrawLinesOnCanvas(0, NUM_OF_MINUTES-1);
      clearRectangle(savedOffset, savedHeight);
      drawReserved(reservedDetail);
      drawRectangle(savedOffset, savedHeight);
      drawCircleAtEdge(savedOffset, savedHeight);
    }

    if (offset < 0)
      offset = 0;
    else if (offset > NUM_OF_MINUTES-1)
      offset = NUM_OF_MINUTES - 1;

    if (processing === 1) {
      currentCursor = 3;
      canvas.current.style.cursor = cursors[currentCursor];
    } else if (reservedStatus[offset].reserved) {
      currentCursor = 0;
      canvas.current.style.cursor = cursors[currentCursor];
    } else if (savedOffset === 0 && cur.y > topBorder && cur.y < topBorder+borderFineTune) {
      currentCursor = 1;
      canvas.current.style.cursor = cursors[currentCursor];
    } else if (savedOffset+savedHeight === NUM_OF_MINUTES-1 && cur.y > bottomBorder-borderFineTune && cur.y < bottomBorder) {
      currentCursor = 1;
      canvas.current.style.cursor = cursors[currentCursor];
    } else if ((savedOffset > 0 && cur.y > topBorder && cur.y < topBorder+borderFineTune)
      || (savedOffset !== -1 && savedOffset+savedHeight < NUM_OF_MINUTES-1 && cur.y > bottomBorder-borderFineTune && cur.y < bottomBorder)) {
      currentCursor = 1;
      canvas.current.style.cursor = cursors[currentCursor];
    } else if (reservedStatus[offset].reserved === true && reservedStatus[offset].owner === accounts[0]) {
      currentCursor = 2;
      canvas.current.style.cursor = cursors[currentCursor];
    }  else {
      currentCursor = 0;
      canvas.current.style.cursor = cursors[currentCursor];
    } 

    if (savedOffset === -1 || reservedStatus[savedOffset].reserved)
      return;

    if (resizable) {
      resized = true;

      if (offset < 0)
        offset = 0;
      else if (offset > NUM_OF_MINUTES-1)
        offset = NUM_OF_MINUTES-1;

      height = offset - start;

      if (atEdge === "top") {
        start = savedOffset + savedHeight;
        height = -savedHeight;
        atEdge = null;
      } else if (atEdge === "bottom") {
        start = savedOffset;
        height = savedHeight;
        atEdge = null;
      } 

      if (height < 0) {
        height = -height;
        topleft = start - height;
        upward = true;
      } else if (height === 0) {
        topleft = start - height;
      } else if (height > 0) {
        topleft = start;
        downward = true;
      }

      jitter = height - previousHeight;
      previousHeight = height;

      // When users rapidly move the pointer, they cannot change a rectangle.
      if (jitter === 1) {
        resized = false;
        resizing = true;
      }

      // At the top and bottom of canvas, I prevent users from drawing a rectangle over the border.
      if (topleft === -1) {
        topleft = 0;
        height--;
      } else if (topleft+height === NUM_OF_MINUTES) {
        height--;
      } else if (jitter === -1) {
        resized = false;
        resizing = true;
      }

      if (!resized) {
        if (noUp) {
          return;
        } else if (reservedStatus[offset].reserved && upward) {
          savedOffset = offset+1;
          savedHeight = height-1;
          upward = false;
          noUp = true;
        } else if (noDown) {
          return;
        } else if (reservedStatus[offset].reserved && downward) {
          savedOffset = offset-height;
          savedHeight = height-1;
          downward = false;
          noDown = true;
        }

        resizeRectangle(topleft, height);
        resized = true;
      }
    }
  }

  const onMouseEnter = e => {
    if (savedOffset !== null
      && savedOffset !== -1
      && reservedStatus[savedOffset].index === NOT_EXIST
      && (offset === savedOffset || (offset => savedOffset || offset <= savedOffset+savedHeight)))
      drawCircleAtEdge(savedOffset, savedHeight);
  }

  const onMouseLeave = e => {
    if (resizable) {
      canvasEle.dispatchEvent(new MouseEvent("mouseup", {
        bubbles: false,
        cancelable: true,
      }));
      resizable = false;
    }

    if (savedOffset !== -1) {
      clearRectangle(0, NUM_OF_MINUTES-1);
      redrawLinesOnCanvas(0, NUM_OF_MINUTES-1);
      clearRectangle(savedOffset, savedHeight);
      drawRectangle(savedOffset, savedHeight);
      drawReserved(reservedDetail);
    }
  }

  const makeReservedDetail = _reserveOfDay => {
    if (_reserveOfDay === [])
      return [];

    const _year = date.getFullYear();
    const _month = date.getMonth();
    const _date = date.getDate();
    const _curDay = new Date(_year, _month, _date);
    const base = _curDay.getTime() / 1000;

    let start = -1;
    let end = -1;

    for (let i = 0; i < _reserveOfDay.length; i++) {
      start = (_reserveOfDay[i].startTime - base)/ TIME_BIN;
      end = (_reserveOfDay[i].endTime - base) / TIME_BIN;
      height = end - start - 1;

      reservedDetail[i] = {
        index: i,
        owner: _reserveOfDay[i].owner,
        offset: start,
        height: height,
        confirming: false,
      }
    }
    setReservedDetail([...reservedDetail]);
  }

  const makeReservedStatus = _reservedDetail => {
    let i = 0;
    let j = -1;

    for (i = 0; i < NUM_OF_MINUTES; i++) {
      reservedStatus[i] = {
        index: NOT_EXIST,
        reserved: false,
        owner: null
      }
    }
    
    if (_reservedDetail === [])
      return;

    for (i = 0; i < _reservedDetail.length; i++) {
      for (j = _reservedDetail[i].offset; j < _reservedDetail[i].offset+_reservedDetail[i].height+1; j++) { // +1 for the boundary.
        reservedStatus[j] = {
          index: i,
          reserved: true,
          owner: _reservedDetail[i].owner
        }
      }
    }
  }

  const addReserving = (_reservedDetail, _confirmedReserve) => {
    const { type, _jabraNumber, confirmedStart, confirmedEnd } = _confirmedReserve;

    if (_jabraNumber !== jabraNumber)
      return;

    const thisDay = date.getDate();
    const startDate = new Date(confirmedStart);
    const startDay = startDate.getDate();
    const startHours = startDate.getHours();
    const startMinutes = startDate.getMinutes();
    const _offset= (startHours*60 + startMinutes) / MINUTES_UNIT;

    const endDate = new Date(confirmedEnd);
    const endDay = endDate.getDate();
    const endHours = endDate.getHours();
    const endMinutes = endDate.getMinutes();
    const HOURS_OF_DAYS = 24;
    var _height = null;

    var markingIndex = null;

    if (thisDay !== startDay)
      return;

    if (endDay === startDay)
      _height = (endHours*60 + endMinutes)/MINUTES_UNIT - _offset - 1; // height begins at 0.
    else if (endDay === startDay+1)
      _height = (HOURS_OF_DAYS*60)/MINUTES_UNIT - _offset - 1; // height begins at 0.

    /*for (let i = 0; i < _reservedDetail.length; i++)
      if ( _offset === _reservedDetail[i].offset)
        return;*/

    markingIndex = _reservedDetail.findIndex(elm => elm.offset === _offset);
    if (type === "reserve" && markingIndex === -1)
      _reservedDetail.push({ index: -1, owner: accounts[0], offset: _offset, height: _height, confirming: true });
    else if (type === "cancel" && markingIndex !== -1)
      _reservedDetail.splice(markingIndex, 1, { index: -2, owner: accounts[0], offset: _offset, height: _height, confirming: true });

    setReservedDetail([..._reservedDetail]);
  }

  const drawReserved = reservedDetail => {
    var i = -1;

    for (i = 0; i < reservedDetail.length; i++)
      if (reservedDetail[i].confirming) {
        clearRectangle(reservedDetail[i].offset, reservedDetail[i].height);
        drawRectangleWithColor(reservedDetail[i].offset, reservedDetail[i].height, "#FFFCDD", "#FFFAC4");
        drawRectangleWithLine(reservedDetail[i].offset, reservedDetail[i].height, "#FFF136");
      } else if (reservedDetail[i].owner === accounts[0]) {
        clearRectangle(reservedDetail[i].offset, reservedDetail[i].height);
        drawRectangleWithColor(reservedDetail[i].offset, reservedDetail[i].height, "#69C4CD1A", "#CCEEEE");
        drawRectangleWithLine(reservedDetail[i].offset, reservedDetail[i].height, "#66AACC");
      } else
        drawRectangleWithColor(reservedDetail[i].offset, reservedDetail[i].height, "#E6E6FA", "#C5C5E9");
        //drawRectangleWithColor(reservedDetail[i].offset, reservedDetail[i].height, "#4499AA", "#66AACC");
  }

  // HACK I should implement the algoright of searching.  But I don't have time enough.
  const selectReserved = _offset => {
    var selected = -1;

    for (var i = 0; i < reservedDetail.length; i++) {
      if (!reservedDetail[i].confirming
        && reservedDetail[i].offset <= offset
        && offset <= reservedDetail[i].offset+reservedDetail[i].height) {
        selected = i;
        break;
      } if (reservedDetail[i].confirming
        && reservedDetail[i].offset <= offset
        && offset <= reservedDetail[i].offset+reservedDetail[i].height) {
        return reserveOfDay[i];
      }
    }

    if (selected === -1)
      return {};

    if (!reservedDetail[i].confirming)
      return reserveOfDay[i];
    else
      return null;
  }

  // HACK I wrote function without deep consideration because I don't have time enough.
  // And I wrote the function with phemenological method.  If we think logic deeply, we must hit upon better logics.
  const resizeRectangle = (offset, height) => {
    // HACK The differneces of statetements between up and down are awkward.  Somebody, tell me a better logic.
    if (!noUp && !noDown) {
      clearRectangle(0, NUM_OF_MINUTES-1);
      redrawLinesOnCanvas(0, NUM_OF_MINUTES-1);
      clearRectangle(offset, height);
      drawReserved(reservedDetail);

      drawRectangle(offset, height);

      drawCircleAtEdge(offset, height);
    }
  }

  const drawLine = (info, style = {}) => {
    const { x0, y0, x1, y1 } = info;
    const { color = 'black', width = 1 } = style;

    if (ctx !== null) {
      ctx.beginPath();
      ctx.moveTo(x0, y0);
      ctx.lineTo(x1, y1);
      ctx.strokeStyle = color;
      ctx.lineWidth = width;
      ctx.stroke();
      ctx.closePath();
    }
  }

  const drawLinesOnCanvas = (start, end) => {
    for (var i = start; i < end; i++) {
      if (i % 2 === 0) {
        drawLine({ x0: 0, y0: heightUnit*i, x1: widthUnit, y1: heightUnit*i }, { color: '#C0C0C0', width: 1.0 });
      } else
        drawLine({ x0: 0, y0: heightUnit*i, x1: widthUnit, y1: heightUnit*i }, { color: '#F0F0F0', width: 1.0 });
    }

    if (day !== NUM_OF_DAYS-1) {
      drawLine({ x0: 0, y0: 0, x1: 0, y1: drawingRegion.height }, { color: '#C0C0C0', width: 1.0 });
    } else {
      drawLine({ x0: 0, y0: 0, x1: 0, y1: drawingRegion.height }, { color: '#C0C0C0', width: 1.0 });
      drawLine({ x0: widthUnit, y0: 0, x1: widthUnit, y1: drawingRegion.height }, { color: '#C0C0C0', width: 1.0 });
    }
  }

  // FIXME Do I draw lines twice by function?
  const redrawLinesOnCanvas = (offset, height) => {
    for (var i = offset; i < offset+height+1; i++) {
      if (i % 2 === 0)
        //drawLine({ x0: 0, y0: heightUnit*i, x1: widthUnit, y1: heightUnit*i }, { color: '#00FF00', width: 1.0 });
        drawLine({ x0: 0, y0: heightUnit*i, x1: widthUnit, y1: heightUnit*i }, { color: '#C0C0C0', width: 1.0 });
      else
        //drawLine({ x0: 0, y0: heightUnit*i, x1: widthUnit, y1: heightUnit*i }, { color: '#0000FF', width: 1.0 });
        drawLine({ x0: 0, y0: heightUnit*i, x1: widthUnit, y1: heightUnit*i }, { color: '#F0F0F0', width: 1.0 });
    }
  }

  const drawCircleAtEdge = (offset, height) => {
    const top = 0;
    const bottom = NUM_OF_MINUTES-1;
    const yFineTune = 3;
    var x = widthUnit - 16;
    var y = offset * heightUnit + yFineTune;
    const radius = 8;
    const startAngle = 0;
    const endAngle = 2 * Math.PI;
    const anticlockwise = false;
    const fillColor = '#CCEEEE'

    if (offset !== -1 && !(offset -1 < 0) && offset !== top && !reservedStatus[offset-1].reserved) {
      ctx.beginPath();
      ctx.arc(x, y, radius, startAngle, endAngle, anticlockwise);
      ctx.fillStyle = fillColor;
      ctx.fill();
      ctx.closePath();
    }

    if (offset !== -1 && !(offset+height+1 > NUM_OF_MINUTES-1) && offset !== bottom && !reservedStatus[offset+height+1].reserved) {
      x = 16;
      y = (offset+height+1) * heightUnit - yFineTune; // height begins at 0.  So +1 is needed.
      ctx.beginPath();
      ctx.arc(x, y, radius, startAngle, endAngle, anticlockwise);
      ctx.fillStyle = fillColor;
      ctx.fill();
      ctx.closePath();
    }
  }

  /**
   * FIXME I might be able to merge drawRectangle and resizeRectangle.
   **/
  const drawRectangle = (offset, height) => {
    const fineTune = 3.0;
    // Note that calculate the boundries of rectangles correctly, and we can draw beautiful objects.
    ctx.fillStyle = "#69C4CD1A"
    //ctx.fillStyle = "#4499AA88"
    ctx.fillRect(fineTune, offset*heightUnit+fineTune, widthUnit-fineTune*2, (height+1)*heightUnit-fineTune*2);

    ctx.lineWidth = 2;
    ctx.strokeStyle = "#CCEEEE";
    //ctx.strokeStyle = "#4499AA99";
    ctx.strokeRect(fineTune, offset*heightUnit+fineTune, widthUnit-fineTune*2, (height+1)*heightUnit-fineTune*2);
  }

  const drawRectangleWithLine = (offset, height, strokeStyle) => {
    const color = strokeStyle;
    const width = 8;
    const xFinetune = 6.0;
    const yFinetune = 3.0;
    const finetuneForSparse = 0.25;

    if (ctx !== null && height === 0) {
      ctx.beginPath();
      ctx.moveTo(xFinetune, offset*heightUnit+yFinetune);
      ctx.lineTo(xFinetune, (offset+1)*heightUnit-yFinetune);
      ctx.strokeStyle = color;
      ctx.lineWidth = width;
      ctx.stroke();
      ctx.closePath();

      return;
    }

    for (var i = offset; i < offset+height+1; i++) {
      if (ctx !== null && i === offset) {
        ctx.beginPath();
        ctx.moveTo(xFinetune, i*heightUnit+yFinetune);
        ctx.lineTo(xFinetune, (i+1)*heightUnit);
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.stroke();
        ctx.closePath();
      } else if (ctx !== null && i === offset+height) {
        ctx.beginPath();
        ctx.moveTo(xFinetune, i*heightUnit);
        ctx.lineTo(xFinetune, (i+1)*heightUnit-yFinetune);
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.stroke();
        ctx.closePath();
      } else {
        ctx.beginPath();
        ctx.moveTo(xFinetune, i*heightUnit-1-finetuneForSparse);
        ctx.lineTo(xFinetune, (i+1)*heightUnit+finetuneForSparse);
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.stroke();
        ctx.closePath();
      }
    }
  }

  const drawRectangleWithColor = (offset, height, fillStyle, strokeStyle) => {
    const fineTune = 3.0;
    // Note that calculate the boundries of rectangles correctly, and we can draw beautiful objects.
    ctx.fillStyle = fillStyle;
    ctx.fillRect(fineTune, offset*heightUnit+fineTune, widthUnit-fineTune*2, (height+1)*heightUnit-fineTune*2);

    ctx.lineWidth = 2;
    ctx.strokeStyle = strokeStyle;
    ctx.strokeRect(fineTune, offset*heightUnit+fineTune, widthUnit-fineTune*2, (height+1)*heightUnit-fineTune*2);
  }

  const clearRectangle = (offset, height) => {
    const fineTune = 1.5;
    ctx.fillStyle = "#FFFFFF";
    //ctx.fillStyle = "#0000FF";
    ctx.fillRect(fineTune, offset*heightUnit+fineTune, widthUnit-fineTune*2, (height+1)*heightUnit-fineTune*2);
  }

  const clearRectangleFromParent = (offset, height, curDay, confirming) => {
    if (offset === -1 || selectedReserved === null)
      return;

    clearRectangle(0, NUM_OF_MINUTES-1);
    redrawLinesOnCanvas(0, NUM_OF_MINUTES-1);
    drawReserved(reservedDetail);

    if (curDay === day && !reservedStatus[offset].reserved && Object.keys(selectedReserved).length === 0) {
      clearRectangle(offset, height);
      drawRectangle(offset, height);
    } else if (!confirming) {
      savedOffset = -1;
      savedHeight = -1;
    }

  }

  return (
    <div style={minutesStyles}>
      <canvas
        id={day}
        ref={canvas}
      >
      </canvas>
    </div>
  );
}

const mapStateToProps = state => ({
  accounts: state.accounts,
  synced: state.reserve.synced,
  processing: state.reserve.processing,
  confirmedQueue: state.reserve.confirmedQueue
});

export default connect(mapStateToProps)(Canvas);
